import { createContext } from 'react';

const isoContext = createContext();

export default isoContext;
